import React, { useState } from 'react'

import MainControls from './MainControls'
import Channel from './Channel'
import PlayPattern from './PlayPattern'
import instrumentsParams from './instrumentsParams'
import { useRef } from 'react'
import MyAppBar from '../MyAppBar'
import createScribbleUtils from './../util/createScribbleUtils'

// const scribble = require('./../scribbleSrc/browser-index')

// const orders = ['1032', '2032', '4021', '3052']

// const clips = orders.map((order: string) => ({
// 	pattern: '[xx][xR]'.repeat(4),
// 	notes: scribble.arp({
// 		chords: 'Dm BbM Am FM BbM FM CM Gm',
// 		count: 8,
// 		order,
// 	}),
// 	accent: 'x-xx--xx',
// }))

// clips.forEach((clip: any) => scribble.clip({ synth: 'PolySynth', ...clip }).start())

// @ts-ignore

// const synthChannel = session.createChannel({
// 	synth: 'PolySynth',
// 	clips
// })

// const synthChannel = session.createChannel({
// 	synth: 'PolySynth',
// 	clips: [
// 		{ pattern: '[-x]', notes: 'C4 D#4' }, // notes can be a string
// 		{ pattern: '[--xx]', notes: 'C4' }, // it can contain chord names
// 		{ pattern: '[-xxx]', notes: ['E4', 'D#4'] }, // or an array
// 		{ pattern: 'xxx', notes: scribble.scale('C minor') } // or the scale method
// 	]
// })

// const clips = [
// 	{ pattern: '[xx]' },
// 	{ pattern: 'x' },
// 	{ pattern: 'xxx[xx]' },
// 	{ pattern: 'xx[xx]' },
// 	{ pattern: 'xxx[-x]' }
// ]

// const sample = 'https://scribbletune.com/sounds/kick.wav'

// const kickChannel = session.createChannel({
// 	idx: 'kick',
// 	// sample,
// 	synth: 'PolySynth',
// 	clips
// })

// kickChannel.startClip(1)
// session.startRow(2);
// session.play({
// 	clipDuration: '1:0:0',
// 	channelPatterns: [{
// 		channelIdx: 'kick',
// 		pattern: '012-4413'
// 	}]
// })

// scribble.clip({
// 	synth: 'PolySynth',
// 	pattern: '[xx][xR]'.repeat(4),
// 	notes: scribble.arp({
// 		chords: 'Dm BbM Am FM BbM FM CM Gm',
// 		count: 8,
// 		// order,
// 	}),
// 	accent: 'x-xx--xx',
// }).start()

// use Tone.loaded().then() ?

const initialPlayPattern = {
	clipDuration: '2:0:0',
	channelPatterns: []
}

const initialClips = [{
	notes: 'FM Em Dm FM',
	pattern: 'x__[-x]x__[-x]'
}]

const initialInstrumentName = 'AMSynth'

let scribbleUtils: any = null

const TinyDaw = (props: {
	settings: any
	setTitle: (title: string) => void,
	constants: any,
	onSettingsChange: (settings: any) => void
}) => {
	const {
		settings,
		constants,
		onSettingsChange
	} = props

	const [projectName, setProjectName] = useState('Project 0')

	const [channels, setChannels] = useState<any[]>([])

	const [playPattern, setPlayPattern] = useState<any>(initialPlayPattern)

	const [isPlaying, setIsPlaying] = useState(false)

	const [bpm, setBpm] = useState(120)

	const inputRef = useRef<any>(null)

	const handleAddChannel = () => {
		const idx = 'Channel ' + channels.length

		const channel = {
			idx,
			instrument: {
				name: initialInstrumentName,
				params: instrumentsParams[initialInstrumentName]
			},
			clips: initialClips,
		}

		setChannels([...channels, channel])
		setPlayPattern({
			...playPattern,
			channelPatterns: [
				...playPattern.channelPatterns,
				{
					channelIdx: idx,
					pattern: '0___'
				}
			]
		})

		// createChannel(channel)
	}

	console.log({ channels })

	const handleChannelChange = (channel: any, i: any) => {
		console.log({ onChangeChannel: channels })
		setChannels(Array.from({ ...channels, [i]: channel, length: channels.length }))

		if (channel.idx !== channels[i].idx) {
			setPlayPattern({
				...playPattern,
				channelPatterns: Array.from({
					...playPattern.channelPatterns,
					[i]: {
						...playPattern.channelPatterns[i],
						channelIdx: channel.idx
					},
					length: playPattern.channelPatterns.length
				})
			})
		}

		// Update Tone instrument
		// if (channel.instrument !== channels[i].instrument) {

		// 	if (channel.instrument.name === channels[i].instrument.name)// change instrument params
		// 		toneInstruments[i].set(channel.instrument.params)
		// 	else {// change tone instrument
		// 		toneInstruments[i] = createToneInstrument(channel.instrument)
		// 	}
		// }
	}

	const handleChangePlayPattern = (playPattern: any) => {// TODO: disable play button if playPattern contains clip that are not existant
		setPlayPattern(playPattern)
	}


	const handleLoadDemo = (demo: any) => {
		console.log({ demo })

		setProjectName(demo.name)
		setPlayPattern(demo.playPattern)
		setChannels(demo.channels)
		handleChangeBpm(demo.config.bpm)
	}

	const handleExportProject = () => {
		var element = document.createElement('a')
		element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify({
			name: projectName,
			config: {
				bpm
			},
			playPattern,
			channels,
		}, null, '\t')))
		element.setAttribute('download', projectName + '.td.json')

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)
	}

	const handleImportProject = (e: any) => {
		const file = e.target.files[0]
		if (!file) {
			return
		}
		const reader = new FileReader()
		reader.onload = (e: any) => {
			const data = JSON.parse(e.target.result)

			// TODO : check if data is fine

			setProjectName(data.name)
			setPlayPattern(data.playPattern)
			setChannels(data.channels)
			handleChangeBpm(data.config.bpm)
		}
		reader.readAsText(file)
	}

	const handlePlay = async () => {// TODO : update to work with pause
		scribbleUtils = await createScribbleUtils(channels)

		scribbleUtils.play(playPattern, undefined, () => setIsPlaying(false))

		setIsPlaying(true)
	}

	const handleChangeBpm = (bpm: number = 120) => {
		global.Tone.Transport.bpm.value = bpm
		setBpm(bpm)
	}

	const handleChannelDelete = (channel: any, i: number) => {
		setChannels(channels.filter((c, i2) => i2 !== i))
		setPlayPattern({
			...playPattern,
			channelPatterns: playPattern.channelPatterns.filter((p: any, i2: number) => i2 !== i)
		})
	}

	const handleStop = () => {
		scribbleUtils.stop()
		setIsPlaying(false)
	}


	return (
		<div id='tiny-daw'>

			<MyAppBar
        constants={constants}
        onSettingsChange={onSettingsChange}
        settings={settings}
      />

			<MainControls
				projectName={projectName}
				onProjectNameChange={setProjectName}
				onAddChannel={handleAddChannel}
				onPlay={handlePlay}
				onPause={() => {
					return// TODO
					global.Tone.Transport.pause()
					setIsPlaying(false)
				}}
				onStop={handleStop}
				isPlaying={isPlaying}
				onLoadDemo={(demo) => handleLoadDemo(demo)}
				onExportProject={() => handleExportProject()}
				onImportProject={() => inputRef?.current?.click()}
			/>

			<div style={{ display: 'flex', marginTop: 24, overflowX: 'scroll', paddingBottom: 10, paddingRight: 24 }}>

				<PlayPattern
					playPattern={playPattern}
					onChange={handleChangePlayPattern}
				/>

				{channels.map((channel, i) => (
					<Channel
						channel={channel}
						onChange={(channel) => handleChannelChange(channel, i)}
						onDelete={(channel) => handleChannelDelete(channel, i)}
					/>
				))}

			</div>

			<input type='file' ref={inputRef} style={{ display: 'none' }} onChange={handleImportProject} />

		</div>
	)
}

export default TinyDaw

// TODO : Add synths presets (:BASSGUITAR)

// DONE : Fix cors call should not be emitted

// DONE : Add design
// TODO : Add more demos

// TODO : Add TinyDaw settings modal (bpm)



// TODO : Add dragndrop feature